/* unplugin-vue-components disabled */import script from "./CIFADetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./CIFADetails.vue?vue&type=script&setup=true&lang=ts"

import "./CIFADetails.vue?vue&type=style&index=0&id=4ea0e3f5&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ea0e3f5"]])

export default __exports__